import { buildAddressGroupingKey } from './address-normalization.util';

export interface LenIdentityKey {
  /** Lowercased + trimmed LEN name. */
  name: string;
  /** Fingerprint of street1|city|state|zip, normalized via buildAddressGroupingKey
   *  (ignores street2/units/case/whitespace) plus the zip suffix. */
  addressKey: string;
}

/** SA identity key — same normalization rules as the existing crossLenDuplicateSas detector. */
export function buildSaIdentityKey(addr: {
  street1?: string | null;
  city?: string | null;
  state?: string | null;
}): string {
  return buildAddressGroupingKey(addr.street1 ?? '', addr.city ?? '', addr.state ?? '');
}

/** LEN identity key — name + (street1+city+state+zip) fingerprint. */
export function buildLenIdentityKey(
  name: string | null | undefined,
  billingAddress: {
    street1?: string | null;
    street2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
  } | null | undefined,
): LenIdentityKey {
  const normalizedName = (name ?? '').trim().toLowerCase();
  const street1City = buildAddressGroupingKey(
    billingAddress?.street1 ?? '',
    billingAddress?.city ?? '',
    billingAddress?.state ?? '',
  );
  const zip = (billingAddress?.zip ?? '').trim().toLowerCase();
  return { name: normalizedName, addressKey: `${street1City}|${zip}` };
}

export function lensAreIdentical(a: LenIdentityKey, b: LenIdentityKey): boolean {
  return a.name === b.name && a.addressKey === b.addressKey;
}

export function lensShareNameDiffAddress(a: LenIdentityKey, b: LenIdentityKey): boolean {
  return a.name === b.name && a.name.length > 0 && a.addressKey !== b.addressKey;
}
